import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { ActivityAndAudienceTable } from "./metrics/activity-and-audience/ActivityAndAudienceTable";
import { SocialMediaEngagementTable } from "./metrics/engagement/SocialMediaEngagementTable";
import { SocialMediaMetricsOverTime } from "./metrics/metrics-over-time/SocialMediaMetricsOverTime";
import { ShareOfPosts } from "./metrics/ShareOfPosts";
import { ShareOfViews } from "./metrics/ShareOfViews";

export const SocialMediaMetrics = () => (
    <Stack
        gap="32px"
        width="100%"
        data-automation="social-media-metrics-container"
    >
        <Flex
            gap="32px"
            width="100%"
        >
            <Flex
                flex={1}
                width="100%"
            >
                <ShareOfPosts />
            </Flex>
            <Flex
                flex={1}
                width="100%"
            >
                <ShareOfViews />
            </Flex>
        </Flex>
        <ActivityAndAudienceTable />
        <SocialMediaEngagementTable />
        <SocialMediaMetricsOverTime />
    </Stack>
);
